// src/pages/Cms/LoginCard.jsx
import React, { useState } from "react";
import { cmsLogin, setTokens } from "../../../../utils/cmsAuth";
import { useAuth } from "./AuthContext";
import { useNavigate, useLocation } from "react-router-dom";

const Login = () => {
  const { reload } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from?.pathname; // 보호 라우트에서 온 경우 복귀 경로

  const [username, setUsername] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const doLogin = async () => {
    if (loading) return; // 중복 클릭 방지
    const u = username.trim();
    if (!u || !pw) return setErr("아이디와 비밀번호를 입력하세요.");
    setErr(""); setLoading(true);
    try {
      const r = await cmsLogin(u, pw);
      setTokens(r.access_token, r.refresh_token);
      await reload(); // 전역 me 1회 갱신
      // 원래 가려던 곳이 있으면 그리로, 없으면 /cms
      nav(from || "/cms", { replace: true });
    } catch (e) {
      setErr(e?.message || "로그인 실패");
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (e) => { e.preventDefault(); doLogin(); };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="w-full max-w-[420px]">
        <div className="rounded-2xl bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.06),0_40px_80px_-24px_rgba(0,0,0,0.12)] p-6">
          <div className="text-lg font-semibold mb-6">
            wiz Market App. 관리자 시스템
          </div>

          <form className="space-y-3" onSubmit={onSubmit}>
            <input
              className="w-full rounded-md border border-neutral-200 px-3 py-2 outline-none focus:border-[#7864F9]"
              placeholder="관리자 아이디"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
            />
            <div className="flex gap-3">
              <input
                className="flex-1 rounded-md border border-neutral-200 px-3 py-2 outline-none focus:border-[#7864F9]"
                type="password"
                placeholder="비밀번호"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                disabled={loading}
              />
              <button
                type="submit"
                disabled={loading}
                className="w-[96px] rounded-md bg-[#7864F9] text-white font-semibold hover:opacity-95 disabled:opacity-60"
              >
                {loading ? "..." : "로그인"}
              </button>
            </div>

            {err && <div className="text-sm text-red-500 mt-1">{err}</div>}
          </form>

          <div className="mt-6 text-center text-xs text-neutral-400">
            Copyright© 주식회사 lyves. All rights reserved
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
